import { render, staticRenderFns } from "./HorizontalNavMenuLink.vue?vue&type=template&id=7f350a3a"
import script from "./HorizontalNavMenuLink.vue?vue&type=script&lang=js"
export * from "./HorizontalNavMenuLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports